import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { App } from 'src/app/models/app';
import { ApplicationHubService } from 'src/app/services/application-hub.service';

@Component({
  selector: 'app-detail',
  templateUrl: './app-detail.component.html',
  styleUrls: ['./app-detail.component.scss']
})
export class AppDetailComponent implements OnInit {

  constructor(private route: ActivatedRoute, private service: ApplicationHubService) { }

  Id: number | undefined;
  App: App | undefined;
  Loading = false;
  NotFound = false;
  Deleted = false;
  Updated = false;

  fetchData(id: number) {
    this.Loading = true;

    this.service.getAppById(id).subscribe(data => {
      this.App = data;
      this.Loading = false;
      if(this.App == null || this.App == undefined)
        this.NotFound = true;
    }, error => {
      console.error('Error:',error);
      this.NotFound = true;
      this.Loading = false;
    }
  );    
  }

  ngOnInit(): void {
    this.route.params.subscribe(x => {
      const id = x["id"];
      this.Id = id;
      
      this.fetchData(id);
    })
  }

  save(): void {

    if(this.App === undefined)
      return;

    this.Loading = true;

    this.service.post(this.App).subscribe(response => {
      console.log('Response from .NET:', response);
      this.Updated = true;
      this.Loading = false;
    }, error => {
      console.error('Error:', error);
      this.Loading = false;
    });
  }

  delete(): void {
    if(this.App === undefined || this.App.Id === undefined)
      return;

    this.Loading = true;

    this.service.deleteAppById(this.App.Id).subscribe(response => {
      console.log('Response from .NET:', response);
      this.Deleted = true;
      this.Loading = false;
    }, error => {
      console.error('Error:', error);
      this.Loading = false;
    });
  }
}
